import React from 'react';
import './SummaryCard.scss';


const SummaryCard = ({title, attributes, actionTitle, actionFunction}) => {
    return (
        <div className={'summary-card-container'}>
            <div className={'summary-card-title-attributes-container'}>
                <div className={'summary-card-text-container'}>
                    <p className={'subtitle-1 v2-c-text-title'}>{title}</p>
                </div>
                <div className={'summary-card-attributes-container'}>
                    {attributes.map((attribute, index) => {
                        return (
                            <p className={'body-2 c-text-base'} key={index}>{attribute}</p>
                        );
                    })}
                </div>
            </div>
            <p className={'body-4 v2-c-primary-500 cursor-pointer'} onClick={actionFunction}>{actionTitle}</p>
        </div>
    );
};
export default SummaryCard;
